import RouteProvider from "./routes";

function App() {
  return (
    <>
      <RouteProvider />
    </>
  );
}

export default App;
